import { USER_REQUEST, USER_SUCCESS, AUTH_ERROR, AUTH_LOGOUT } from "../../constants";
import api from "../../utils/api";
import localData from "../../utils/localdata";

const actions = {
	[USER_REQUEST]: ({ rootState, commit, dispatch }, user) => {
		return new Promise(async (resolve, reject) => {
			try {
				const resp = await api.get("/api/v1/user");
				commit(USER_SUCCESS, resp.user);
				resolve(resp.user);
				//TODO finish this
			} catch (err) {
				commit(AUTH_ERROR, err);
				dispatch(AUTH_LOGOUT);
				reject(err);
			}
		});
	},
};

export default actions;
